export const topic = [
    { "label": "Efficacy", "value": "efficacy" },
    { "label": "Safety", "value": "safety" },
    { "label": "Dosing", "value": "dosing" },
    { "label": "MoA", "value": "MoA" },
    { "label": "Testing", "value": "testing" },
    { "label": "Diseases State Awareness", "value": "diseases_state_awareness" }
]
export const content_type = [
    { "label": 'Branded', "value": "Branded" },
    { "label": 'Unbranded', "value": "Unbranded" }
]
export const subject_line = [
    { "label": 'Branded', "value": "Branded" },
    { "label": 'Unbranded', "value": "Unbranded" }
]
export const CHANNELS = [
    {
        "id": 1,
        "partner_id": 2,
        "campaign_type_id": 4,
        "created_at": "2022-09-26T06:37:52.000000Z",
        "updated_at": "2022-09-26T06:37:52.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 4,
            "name": "Banner Ad",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2020-11-11T17:14:13.000000Z",
            "selected": 0,
            "template_id": 1
        },
        "partner": {
            "id": 2,
            "name": "BioPharm",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2020-11-11T17:14:13.000000Z",
            "machine_name": "biopharm",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 2,
        "partner_id": 2,
        "campaign_type_id": 5,
        "created_at": "2022-09-26T06:37:52.000000Z",
        "updated_at": "2022-09-26T06:37:52.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 5,
            "name": "Direct Mail",
            "created_at": null,
            "updated_at": "2022-09-24T12:20:14.000000Z",
            "selected": 0,
            "template_id": 2
        },
        "partner": {
            "id": 2,
            "name": "BioPharm",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2020-11-11T17:14:13.000000Z",
            "machine_name": "biopharm",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 3,
        "partner_id": 2,
        "campaign_type_id": 1,
        "created_at": "2022-09-26T06:37:52.000000Z",
        "updated_at": "2022-09-26T06:37:52.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 1,
            "name": "Email",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2022-09-24T12:20:14.000000Z",
            "selected": 0,
            "template_id": 2
        },
        "partner": {
            "id": 2,
            "name": "BioPharm",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2020-11-11T17:14:13.000000Z",
            "machine_name": "biopharm",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 4,
        "partner_id": 3,
        "campaign_type_id": 4,
        "created_at": "2022-09-26T06:37:52.000000Z",
        "updated_at": "2022-09-26T06:37:52.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 4,
            "name": "Banner Ad",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2020-11-11T17:14:13.000000Z",
            "selected": 0,
            "template_id": 1
        },
        "partner": {
            "id": 3,
            "name": "Medscape",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2020-11-11T17:14:13.000000Z",
            "machine_name": "medscape",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 5,
        "partner_id": 5,
        "campaign_type_id": 15,
        "created_at": "2022-09-26T06:37:52.000000Z",
        "updated_at": "2022-09-26T06:37:52.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 15,
            "name": "Programmatic",
            "created_at": null,
            "updated_at": null,
            "selected": 0,
            "template_id": 1
        },
        "partner": {
            "id": 5,
            "name": "Programmatic",
            "created_at": "2020-12-09T22:49:05.000000Z",
            "updated_at": "2020-12-09T22:49:05.000000Z",
            "machine_name": "programmatic",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 6,
        "partner_id": 16,
        "campaign_type_id": 4,
        "created_at": "2022-09-26T06:37:52.000000Z",
        "updated_at": "2022-09-26T06:37:52.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 4,
            "name": "Banner Ad",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2020-11-11T17:14:13.000000Z",
            "selected": 0,
            "template_id": 1
        },
        "partner": {
            "id": 16,
            "name": "OncLive",
            "created_at": null,
            "updated_at": null,
            "machine_name": "onclive",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 7,
        "partner_id": 16,
        "campaign_type_id": 5,
        "created_at": "2022-09-26T06:37:52.000000Z",
        "updated_at": "2022-09-26T06:37:52.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 5,
            "name": "Direct Mail",
            "created_at": null,
            "updated_at": "2022-09-24T12:20:14.000000Z",
            "selected": 0,
            "template_id": 2
        },
        "partner": {
            "id": 16,
            "name": "OncLive",
            "created_at": null,
            "updated_at": null,
            "machine_name": "onclive",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 8,
        "partner_id": 16,
        "campaign_type_id": 1,
        "created_at": "2022-09-26T06:37:52.000000Z",
        "updated_at": "2022-09-26T06:37:52.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 1,
            "name": "Email",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2022-09-24T12:20:14.000000Z",
            "selected": 0,
            "template_id": 2
        },
        "partner": {
            "id": 16,
            "name": "OncLive",
            "created_at": null,
            "updated_at": null,
            "machine_name": "onclive",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 9,
        "partner_id": 10,
        "campaign_type_id": 1,
        "created_at": "2022-09-26T06:37:52.000000Z",
        "updated_at": "2022-09-26T06:37:52.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 1,
            "name": "Email",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2022-09-24T12:20:14.000000Z",
            "selected": 0,
            "template_id": 2
        },
        "partner": {
            "id": 10,
            "name": "Connexions360",
            "created_at": null,
            "updated_at": null,
            "machine_name": "connexions360",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 10,
        "partner_id": 12,
        "campaign_type_id": 4,
        "created_at": "2022-09-26T06:37:52.000000Z",
        "updated_at": "2022-09-26T06:37:52.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 4,
            "name": "Banner Ad",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2020-11-11T17:14:13.000000Z",
            "selected": 0,
            "template_id": 1
        },
        "partner": {
            "id": 12,
            "name": "Sermo",
            "created_at": null,
            "updated_at": null,
            "machine_name": "sermo",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 16,
        "partner_id": 4,
        "campaign_type_id": 4,
        "created_at": "2022-09-26T06:51:30.000000Z",
        "updated_at": "2022-09-26T06:51:30.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 4,
            "name": "Banner Ad",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2020-11-11T17:14:13.000000Z",
            "selected": 0,
            "template_id": 1
        },
        "partner": {
            "id": 4,
            "name": "Client",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2022-12-03T15:03:22.000000Z",
            "machine_name": "emd_serono",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 17,
        "partner_id": 4,
        "campaign_type_id": 5,
        "created_at": "2022-09-26T06:51:30.000000Z",
        "updated_at": "2022-09-26T06:51:30.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 5,
            "name": "Direct Mail",
            "created_at": null,
            "updated_at": "2022-09-24T12:20:14.000000Z",
            "selected": 0,
            "template_id": 2
        },
        "partner": {
            "id": 4,
            "name": "Client",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2022-12-03T15:03:22.000000Z",
            "machine_name": "emd_serono",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 18,
        "partner_id": 4,
        "campaign_type_id": 1,
        "created_at": "2022-09-26T06:51:30.000000Z",
        "updated_at": "2022-09-26T06:51:30.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 1,
            "name": "Email",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2022-09-24T12:20:14.000000Z",
            "selected": 0,
            "template_id": 2
        },
        "partner": {
            "id": 4,
            "name": "Client",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2022-12-03T15:03:22.000000Z",
            "machine_name": "emd_serono",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 37,
        "partner_id": 4,
        "campaign_type_id": 3,
        "created_at": "2022-12-05T12:20:09.000000Z",
        "updated_at": "2022-12-05T12:20:09.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 3,
            "name": "Sales Rep",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2022-09-24T12:20:14.000000Z",
            "selected": 0,
            "template_id": 4
        },
        "partner": {
            "id": 4,
            "name": "Client",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2022-12-03T15:03:22.000000Z",
            "machine_name": "emd_serono",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 84,
        "partner_id": 36,
        "campaign_type_id": 15,
        "created_at": "2023-03-12T07:56:35.000000Z",
        "updated_at": "2023-03-12T07:56:35.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 15,
            "name": "Programmatic",
            "created_at": null,
            "updated_at": null,
            "selected": 0,
            "template_id": 1
        },
        "partner": {
            "id": 36,
            "name": "PulsePoint",
            "created_at": null,
            "updated_at": null,
            "machine_name": "pulsePoint",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 87,
        "partner_id": 10,
        "campaign_type_id": 17,
        "created_at": "2023-03-14T14:34:44.000000Z",
        "updated_at": "2023-03-14T14:34:44.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 17,
            "name": "Endemic Social Media",
            "created_at": null,
            "updated_at": null,
            "selected": 0,
            "template_id": 1
        },
        "partner": {
            "id": 10,
            "name": "Connexions360",
            "created_at": null,
            "updated_at": null,
            "machine_name": "connexions360",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    },
    {
        "id": 499,
        "partner_id": 94,
        "campaign_type_id": 1,
        "created_at": "2023-10-19T19:00:52.000000Z",
        "updated_at": "2023-10-19T19:00:52.000000Z",
        "company_id": 3,
        "campaign_type": {
            "id": 1,
            "name": "Email",
            "created_at": "2020-11-11T17:14:13.000000Z",
            "updated_at": "2022-09-24T12:20:14.000000Z",
            "selected": 0,
            "template_id": 2
        },
        "partner": {
            "id": 94,
            "name": "Client_Internal",
            "created_at": null,
            "updated_at": null,
            "machine_name": "client_internal",
            "use_sftp": true,
            "active": 0,
            "use_engagement": 1
        }
    }
];

export const LIST = [
    {
        "id": 1,
        "channel_name": "",
        "name": "Target List",
        "slug": "manual",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "NPI",
                "slug": "npi",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 1,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "IMS_ID",
                "slug": "ims_id",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 2,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "AMA_Do_Not_Contact",
                "slug": "ama_do_not_contact",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 3,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "FIRST_NAME",
                "slug": "FIRST_NAME",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 4,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "LAST_NAME",
                "slug": "LAST_NAME",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 5,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Specialty",
                "slug": "Specialty",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 6,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "ADDRESS1",
                "slug": "ADDRESS1",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 7,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "ADDRESS2",
                "slug": "ADDRESS2 ",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 8,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CITY",
                "slug": "CITY",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 9,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "STATE",
                "slug": "STATE",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 10,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Zip",
                "slug": "Zip",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 11,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "PHONE_NUMBER",
                "slug": "PHONE_NUMBER",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 12,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Lung_Decile",
                "slug": "Lung_Decile",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 13,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Partner_Preference",
                "slug": "Partner_Preference",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 14,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Segmentation",
                "slug": "Segmentation",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 15,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Channel_Preference",
                "slug": "Channel_Preference",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 16,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "District",
                "slug": "District",
                "status": 1,
                "file_setup_type_id": 1,
                "id": 17,
                "filesetupfieldmapping": null
            }
        ]
    },
    {
        "id": 2,
        "channel_name": "",
        "name": "Prescription",
        "slug": "prescription",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "ID",
                "slug": "id",
                "status": 1,
                "file_setup_type_id": 2,
                "id": 118,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "NPI_ID",
                "slug": "npi_id",
                "status": 1,
                "file_setup_type_id": 2,
                "id": 119,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Timestamp",
                "slug": "timestamp",
                "status": 1,
                "file_setup_type_id": 2,
                "id": 120,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Action",
                "slug": "action",
                "status": 1,
                "file_setup_type_id": 2,
                "id": 121,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_LINE",
                "slug": "subject_line",
                "status": 1,
                "file_setup_type_id": 2,
                "id": 122,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Time",
                "slug": "time",
                "status": 1,
                "file_setup_type_id": 2,
                "id": 123,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CHANNEL",
                "slug": "channel",
                "status": 1,
                "file_setup_type_id": 2,
                "id": 124,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TYPE",
                "slug": "content_type",
                "status": 1,
                "file_setup_type_id": 2,
                "id": 125,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TOPIC",
                "slug": "content_topic",
                "status": 1,
                "file_setup_type_id": 2,
                "id": 126,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_TYPE",
                "slug": "subject_type",
                "status": 1,
                "file_setup_type_id": 2,
                "id": 127,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "File_Name",
                "slug": "file_name",
                "status": 1,
                "file_setup_type_id": 2,
                "id": 128,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Delimiter",
                "slug": "delimiter",
                "status": 1,
                "file_setup_type_id": 2,
                "id": 129,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Date_Format",
                "slug": "date_format",
                "status": 1,
                "file_setup_type_id": 2,
                "id": 130,
                "filesetupfieldmapping": null
            }
        ]
    },
    {
        "id": 3,
        "channel_name": "Email",
        "name": "Email",
        "slug": "email",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "ID",
                "slug": "id",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 18,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 18,
                    "company_id": 3,
                    "value": "ID",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "NPI_ID",
                "slug": "npi_id",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 19,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 19,
                    "company_id": 3,
                    "value": "NPI_ID",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "Timestamp",
                "slug": "timestamp",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 20,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 20,
                    "company_id": 3,
                    "value": "Timestamp",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "Action",
                "slug": "action",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 21,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 21,
                    "company_id": 3,
                    "value": "Action",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "SUBJECT_LINE",
                "slug": "subject_line",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 22,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 22,
                    "company_id": 3,
                    "value": "SUBJECT_LINE",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "Time",
                "slug": "time",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 23,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 23,
                    "company_id": 3,
                    "value": "Time",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "CHANNEL",
                "slug": "channel",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 24,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 24,
                    "company_id": 3,
                    "value": "CHANNEL",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "CONTENT_TYPE",
                "slug": "content_type",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 25,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TOPIC",
                "slug": "content_topic",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 26,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_TYPE",
                "slug": "subject_type",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 27,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "File_Name",
                "slug": "file_name",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 131,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Delimiter",
                "slug": "delimiter",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 132,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 132,
                    "company_id": 3,
                    "value": "|",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "Date_Format",
                "slug": "date_format",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 133,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 133,
                    "company_id": 3,
                    "value": "YYYY-MM-DD",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "Indication",
                "slug": "indication",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 227,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Assets",
                "slug": "assets",
                "status": 1,
                "file_setup_type_id": 3,
                "id": 228,
                "filesetupfieldmapping": null
            }
        ]
    },
    {
        "id": 4,
        "channel_name": "Banner Ad",
        "name": "Banner Ad",
        "slug": "banner_ad",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "ID",
                "slug": "id",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 28,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "NPI_ID",
                "slug": "npi_id",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 29,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Timestamp",
                "slug": "timestamp",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 30,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Action",
                "slug": "action",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 31,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_LINE",
                "slug": "subject_line",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 32,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Time",
                "slug": "time",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 33,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CHANNEL",
                "slug": "channel",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 34,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TYPE",
                "slug": "content_type",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 35,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TOPIC",
                "slug": "content_topic",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 36,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_TYPE",
                "slug": "subject_type",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 37,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "File_Name",
                "slug": "file_name",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 134,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 134,
                    "company_id": 3,
                    "value": "PFIQ_BIOPHARM_ENGAGEMENT_BANNER_AD.txt",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "Delimiter",
                "slug": "delimiter",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 135,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 135,
                    "company_id": 3,
                    "value": "|",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "Date_Format",
                "slug": "date_format",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 136,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 136,
                    "company_id": 3,
                    "value": "YYYY-MM-DD",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "Indication",
                "slug": "indication",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 229,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Assets",
                "slug": "assets",
                "status": 1,
                "file_setup_type_id": 4,
                "id": 230,
                "filesetupfieldmapping": null
            }
        ]
    },
    {
        "id": 5,
        "channel_name": "Direct Mail",
        "name": "Direct Mail",
        "slug": "direct_mail",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "ID",
                "slug": "id",
                "status": 1,
                "file_setup_type_id": 5,
                "id": 38,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "NPI_ID",
                "slug": "npi_id",
                "status": 1,
                "file_setup_type_id": 5,
                "id": 39,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Timestamp",
                "slug": "timestamp",
                "status": 1,
                "file_setup_type_id": 5,
                "id": 40,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Action",
                "slug": "action",
                "status": 1,
                "file_setup_type_id": 5,
                "id": 41,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_LINE",
                "slug": "subject_line",
                "status": 1,
                "file_setup_type_id": 5,
                "id": 42,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Time",
                "slug": "time",
                "status": 1,
                "file_setup_type_id": 5,
                "id": 43,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CHANNEL",
                "slug": "channel",
                "status": 1,
                "file_setup_type_id": 5,
                "id": 44,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TYPE",
                "slug": "content_type",
                "status": 1,
                "file_setup_type_id": 5,
                "id": 45,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TOPIC",
                "slug": "content_topic",
                "status": 1,
                "file_setup_type_id": 5,
                "id": 46,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_TYPE",
                "slug": "subject_type",
                "status": 1,
                "file_setup_type_id": 5,
                "id": 47,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "File_Name",
                "slug": "file_name",
                "status": 1,
                "file_setup_type_id": 5,
                "id": 137,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 137,
                    "company_id": 3,
                    "value": "PFIQ_BIOPHARM_ENGAGEMENT_DIRECT_MAIL.txt",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "Delimiter",
                "slug": "delimiter",
                "status": 1,
                "file_setup_type_id": 5,
                "id": 138,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 138,
                    "company_id": 3,
                    "value": "|",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            },
            {
                "field_name": "Date_Format",
                "slug": "date_format",
                "status": 1,
                "file_setup_type_id": 5,
                "id": 139,
                "filesetupfieldmapping": {
                    "file_setup_field_id": 139,
                    "company_id": 3,
                    "value": "YYYY-MM-DD",
                    "status": 1,
                    "channel_id": 2,
                    "partnerchannel": {
                        "partner_id": 2
                    }
                }
            }
        ]
    },
    {
        "id": 6,
        "channel_name": "EHR",
        "name": "EHR",
        "slug": "ehr",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "ID",
                "slug": "id",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 48,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "NPI_ID",
                "slug": "npi_id",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 49,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Timestamp",
                "slug": "timestamp",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 50,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Action",
                "slug": "action",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 51,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_LINE",
                "slug": "subject_line",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 52,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Time",
                "slug": "time",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 53,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CHANNEL",
                "slug": "channel",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 54,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TYPE",
                "slug": "content_type",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 55,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TOPIC",
                "slug": "content_topic",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 56,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_TYPE",
                "slug": "subject_type",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 57,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "File_Name",
                "slug": "file_name",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 140,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Delimiter",
                "slug": "delimiter",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 141,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Date_Format",
                "slug": "date_format",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 142,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Indication",
                "slug": "indication",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 233,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Assets",
                "slug": "assets",
                "status": 1,
                "file_setup_type_id": 6,
                "id": 234,
                "filesetupfieldmapping": null
            }
        ]
    },
    {
        "id": 7,
        "channel_name": "mobile",
        "name": "Mobile",
        "slug": "mobile",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "ID",
                "slug": "id",
                "status": 1,
                "file_setup_type_id": 7,
                "id": 58,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "NPI_ID",
                "slug": "npi_id",
                "status": 1,
                "file_setup_type_id": 7,
                "id": 59,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Timestamp",
                "slug": "timestamp",
                "status": 1,
                "file_setup_type_id": 7,
                "id": 60,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Action",
                "slug": "action",
                "status": 1,
                "file_setup_type_id": 7,
                "id": 61,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_LINE",
                "slug": "subject_line",
                "status": 1,
                "file_setup_type_id": 7,
                "id": 62,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Time",
                "slug": "time",
                "status": 1,
                "file_setup_type_id": 7,
                "id": 63,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CHANNEL",
                "slug": "channel",
                "status": 1,
                "file_setup_type_id": 7,
                "id": 64,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TYPE",
                "slug": "content_type",
                "status": 1,
                "file_setup_type_id": 7,
                "id": 65,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TOPIC",
                "slug": "content_topic",
                "status": 1,
                "file_setup_type_id": 7,
                "id": 66,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_TYPE",
                "slug": "subject_type",
                "status": 1,
                "file_setup_type_id": 7,
                "id": 67,
                "filesetupfieldmapping": null
            }
        ]
    },
    {
        "id": 8,
        "channel_name": "Peer to Peer",
        "name": "PeerToPeer",
        "slug": "peer_to_peer ",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "ID",
                "slug": "id",
                "status": 1,
                "file_setup_type_id": 8,
                "id": 68,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "NPI_ID",
                "slug": "npi_id",
                "status": 1,
                "file_setup_type_id": 8,
                "id": 69,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Timestamp",
                "slug": "timestamp",
                "status": 1,
                "file_setup_type_id": 8,
                "id": 70,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Action",
                "slug": "action",
                "status": 1,
                "file_setup_type_id": 8,
                "id": 71,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_LINE",
                "slug": "subject_line",
                "status": 1,
                "file_setup_type_id": 8,
                "id": 72,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Time",
                "slug": "time",
                "status": 1,
                "file_setup_type_id": 8,
                "id": 73,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CHANNEL",
                "slug": "channel",
                "status": 1,
                "file_setup_type_id": 8,
                "id": 74,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TYPE",
                "slug": "content_type",
                "status": 1,
                "file_setup_type_id": 8,
                "id": 75,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TOPIC",
                "slug": "content_topic",
                "status": 1,
                "file_setup_type_id": 8,
                "id": 76,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_TYPE",
                "slug": "subject_type",
                "status": 1,
                "file_setup_type_id": 8,
                "id": 77,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Delimiter",
                "slug": "delimiter",
                "status": 1,
                "file_setup_type_id": 8,
                "id": 175,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Date_Format",
                "slug": "date_format",
                "status": 1,
                "file_setup_type_id": 8,
                "id": 176,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "File_Name",
                "slug": "file_name",
                "status": 1,
                "file_setup_type_id": 8,
                "id": 177,
                "filesetupfieldmapping": null
            }
        ]
    },
    {
        "id": 9,
        "channel_name": "Point of Care",
        "name": "Point of Care",
        "slug": "point_of_care",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "ID",
                "slug": "id",
                "status": 1,
                "file_setup_type_id": 9,
                "id": 78,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "NPI_ID",
                "slug": "npi_id",
                "status": 1,
                "file_setup_type_id": 9,
                "id": 79,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Timestamp",
                "slug": "timestamp",
                "status": 1,
                "file_setup_type_id": 9,
                "id": 80,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Action",
                "slug": "action",
                "status": 1,
                "file_setup_type_id": 9,
                "id": 81,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_LINE",
                "slug": "subject_line",
                "status": 1,
                "file_setup_type_id": 9,
                "id": 82,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Time",
                "slug": "time",
                "status": 1,
                "file_setup_type_id": 9,
                "id": 83,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CHANNEL",
                "slug": "channel",
                "status": 1,
                "file_setup_type_id": 9,
                "id": 84,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TYPE",
                "slug": "content_type",
                "status": 1,
                "file_setup_type_id": 9,
                "id": 85,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TOPIC",
                "slug": "content_topic",
                "status": 1,
                "file_setup_type_id": 9,
                "id": 86,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_TYPE",
                "slug": "subject_type",
                "status": 1,
                "file_setup_type_id": 9,
                "id": 87,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Indication",
                "slug": "indication",
                "status": 1,
                "file_setup_type_id": 9,
                "id": 235,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Assets",
                "slug": "assets",
                "status": 1,
                "file_setup_type_id": 9,
                "id": 236,
                "filesetupfieldmapping": null
            }
        ]
    },
    {
        "id": 10,
        "channel_name": "Programmatic",
        "name": "Programmatic",
        "slug": "programmatic",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "ID",
                "slug": "id",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 88,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "NPI_ID",
                "slug": "npi_id",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 89,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Timestamp",
                "slug": "timestamp",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 90,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Action",
                "slug": "action",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 91,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_LINE",
                "slug": "subject_line",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 92,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Time",
                "slug": "time",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 93,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CHANNEL",
                "slug": "channel",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 94,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TYPE",
                "slug": "content_type",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 95,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TOPIC",
                "slug": "content_topic",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 96,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_TYPE",
                "slug": "subject_type",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 97,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "File_Name",
                "slug": "file_name",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 143,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Delimiter",
                "slug": "delimiter",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 144,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Date_Format",
                "slug": "date_format",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 145,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Indication",
                "slug": "indication",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 231,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Assets",
                "slug": "assets",
                "status": 1,
                "file_setup_type_id": 10,
                "id": 232,
                "filesetupfieldmapping": null
            }
        ]
    },
    {
        "id": 11,
        "channel_name": "SMS",
        "name": "SMS",
        "slug": "sms",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "ID",
                "slug": "id",
                "status": 1,
                "file_setup_type_id": 11,
                "id": 98,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "NPI_ID",
                "slug": "npi_id",
                "status": 1,
                "file_setup_type_id": 11,
                "id": 99,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Timestamp",
                "slug": "timestamp",
                "status": 1,
                "file_setup_type_id": 11,
                "id": 100,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Action",
                "slug": "action",
                "status": 1,
                "file_setup_type_id": 11,
                "id": 101,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_LINE",
                "slug": "subject_line",
                "status": 1,
                "file_setup_type_id": 11,
                "id": 102,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Time",
                "slug": "time",
                "status": 1,
                "file_setup_type_id": 11,
                "id": 103,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CHANNEL",
                "slug": "channel",
                "status": 1,
                "file_setup_type_id": 11,
                "id": 104,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TYPE",
                "slug": "content_type",
                "status": 1,
                "file_setup_type_id": 11,
                "id": 105,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TOPIC",
                "slug": "content_topic",
                "status": 1,
                "file_setup_type_id": 11,
                "id": 106,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_TYPE",
                "slug": "subject_type",
                "status": 1,
                "file_setup_type_id": 11,
                "id": 107,
                "filesetupfieldmapping": null
            }
        ]
    },
    {
        "id": 12,
        "channel_name": "Sales Rep",
        "name": "Sales Rep",
        "slug": "sales_rep",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "ID",
                "slug": "id",
                "status": 1,
                "file_setup_type_id": 12,
                "id": 108,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "NPI_ID",
                "slug": "npi_id",
                "status": 1,
                "file_setup_type_id": 12,
                "id": 109,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Timestamp",
                "slug": "timestamp",
                "status": 1,
                "file_setup_type_id": 12,
                "id": 110,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Action",
                "slug": "action",
                "status": 1,
                "file_setup_type_id": 12,
                "id": 111,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_LINE",
                "slug": "subject_line",
                "status": 1,
                "file_setup_type_id": 12,
                "id": 112,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Time",
                "slug": "time",
                "status": 1,
                "file_setup_type_id": 12,
                "id": 113,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CHANNEL",
                "slug": "channel",
                "status": 1,
                "file_setup_type_id": 12,
                "id": 114,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TYPE",
                "slug": "content_type",
                "status": 1,
                "file_setup_type_id": 12,
                "id": 115,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TOPIC",
                "slug": "content_topic",
                "status": 1,
                "file_setup_type_id": 12,
                "id": 116,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_TYPE",
                "slug": "subject_type",
                "status": 1,
                "file_setup_type_id": 12,
                "id": 117,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "File_Name",
                "slug": "file_name",
                "status": 1,
                "file_setup_type_id": 12,
                "id": 146,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Delimiter",
                "slug": "delimiter",
                "status": 1,
                "file_setup_type_id": 12,
                "id": 147,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Date_Format",
                "slug": "date_format",
                "status": 1,
                "file_setup_type_id": 12,
                "id": 148,
                "filesetupfieldmapping": null
            }
        ]
    },
    {
        "id": 13,
        "channel_name": "Endemic Social Media",
        "name": "Endemic Social Media",
        "slug": "endemic_social_media",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "ID",
                "slug": "id",
                "status": 1,
                "file_setup_type_id": 13,
                "id": 149,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "NPI_ID",
                "slug": "npi_id",
                "status": 1,
                "file_setup_type_id": 13,
                "id": 150,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Timestamp",
                "slug": "timestamp",
                "status": 1,
                "file_setup_type_id": 13,
                "id": 151,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Action",
                "slug": "action",
                "status": 1,
                "file_setup_type_id": 13,
                "id": 152,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_LINE",
                "slug": "subject_line",
                "status": 1,
                "file_setup_type_id": 13,
                "id": 153,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Time",
                "slug": "time",
                "status": 1,
                "file_setup_type_id": 13,
                "id": 154,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CHANNEL",
                "slug": "channel",
                "status": 1,
                "file_setup_type_id": 13,
                "id": 155,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TYPE",
                "slug": "content_type",
                "status": 1,
                "file_setup_type_id": 13,
                "id": 156,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TOPIC",
                "slug": "content_topic",
                "status": 1,
                "file_setup_type_id": 13,
                "id": 157,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_TYPE",
                "slug": "subject_type",
                "status": 1,
                "file_setup_type_id": 13,
                "id": 158,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "File_Name",
                "slug": "file_name",
                "status": 1,
                "file_setup_type_id": 13,
                "id": 159,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Delimiter",
                "slug": "delimiter",
                "status": 1,
                "file_setup_type_id": 13,
                "id": 160,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Date_Format",
                "slug": "date_format",
                "status": 1,
                "file_setup_type_id": 13,
                "id": 161,
                "filesetupfieldmapping": null
            }
        ]
    },
    {
        "id": 14,
        "channel_name": "Custom Media",
        "name": "Custom Media",
        "slug": "custom_media",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "ID",
                "slug": "id",
                "status": 1,
                "file_setup_type_id": 14,
                "id": 162,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "NPI_ID",
                "slug": "npi_id",
                "status": 1,
                "file_setup_type_id": 14,
                "id": 163,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Timestamp",
                "slug": "timestamp",
                "status": 1,
                "file_setup_type_id": 14,
                "id": 164,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Action",
                "slug": "action",
                "status": 1,
                "file_setup_type_id": 14,
                "id": 165,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_LINE",
                "slug": "subject_line",
                "status": 1,
                "file_setup_type_id": 14,
                "id": 166,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Time",
                "slug": "time",
                "status": 1,
                "file_setup_type_id": 14,
                "id": 167,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CHANNEL",
                "slug": "channel",
                "status": 1,
                "file_setup_type_id": 14,
                "id": 168,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TYPE",
                "slug": "content_type",
                "status": 1,
                "file_setup_type_id": 14,
                "id": 169,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "CONTENT_TOPIC",
                "slug": "content_topic",
                "status": 1,
                "file_setup_type_id": 14,
                "id": 170,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "SUBJECT_TYPE",
                "slug": "subject_type",
                "status": 1,
                "file_setup_type_id": 14,
                "id": 171,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "File_Name",
                "slug": "file_name",
                "status": 1,
                "file_setup_type_id": 14,
                "id": 172,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Delimiter",
                "slug": "delimiter",
                "status": 1,
                "file_setup_type_id": 14,
                "id": 173,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Date_Format",
                "slug": "date_format",
                "status": 1,
                "file_setup_type_id": 14,
                "id": 174,
                "filesetupfieldmapping": null
            }
        ]
    },
    {
        "id": 15,
        "channel_name": "Web Matrix",
        "name": "Web Matrix",
        "slug": "web_matrix",
        "created_at": null,
        "updated_at": null,
        "filesetupfields": [
            {
                "field_name": "Month_of_Date",
                "slug": "month_of_date",
                "status": 1,
                "file_setup_type_id": 15,
                "id": 178,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Source_Medium_Group",
                "slug": "source_medium_group",
                "status": 1,
                "file_setup_type_id": 15,
                "id": 179,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Package",
                "slug": "package",
                "status": 1,
                "file_setup_type_id": 15,
                "id": 180,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Campaign_Code",
                "slug": "campaign_Code",
                "status": 1,
                "file_setup_type_id": 15,
                "id": 181,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Creative_Name",
                "slug": "creative_name",
                "status": 1,
                "file_setup_type_id": 15,
                "id": 182,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Sessions",
                "slug": "sessions",
                "status": 1,
                "file_setup_type_id": 15,
                "id": 183,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "Quality_Visits",
                "slug": "quality_visits",
                "status": 1,
                "file_setup_type_id": 15,
                "id": 184,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "QVR",
                "slug": "qvr",
                "status": 1,
                "file_setup_type_id": 15,
                "id": 185,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "bounce_rate",
                "slug": "bounce_rate",
                "status": 1,
                "file_setup_type_id": 15,
                "id": 186,
                "filesetupfieldmapping": null
            },
            {
                "field_name": "PVPS",
                "slug": "pvps",
                "status": 1,
                "file_setup_type_id": 15,
                "id": 187,
                "filesetupfieldmapping": null
            }
        ]
    }
];


function extractPartnerInfo(data) {
    const result = [];

    for (const item of data) {
        const partnerName = item.partner.name;
        const machineName = item.partner.machine_name;

        result.push({ label: partnerName, value: machineName });
    }

    return result;
};

export const PARTNERS = extractPartnerInfo(CHANNELS);
